import { EVENT_NOMINATIONS_OVERRIDES } from '@/modules/UserEventLanding/constants';

export default {
  nominations_override: {
    plural: {
      [EVENT_NOMINATIONS_OVERRIDES.NOMINATIONS]: 'номинации | номинации',
      [EVENT_NOMINATIONS_OVERRIDES.SECTIONS]: 'секции | секции',
      [EVENT_NOMINATIONS_OVERRIDES.TRACKS]: 'треки | треке',
      [EVENT_NOMINATIONS_OVERRIDES.TOPICS]: 'тематики | тематике',
      [EVENT_NOMINATIONS_OVERRIDES.SITES]: 'площадки | площадке',
      [EVENT_NOMINATIONS_OVERRIDES.CATEGORIES]: 'рубрики | рубрике',
      [EVENT_NOMINATIONS_OVERRIDES.DIRECTIONS]: 'направления | направлении',
      [EVENT_NOMINATIONS_OVERRIDES.DISCIPLINES]: 'дисциплины | дисциплине',
    },
    default: {
      [EVENT_NOMINATIONS_OVERRIDES.NOMINATIONS]: 'номинацию',
      [EVENT_NOMINATIONS_OVERRIDES.SECTIONS]: 'секцию',
      [EVENT_NOMINATIONS_OVERRIDES.TRACKS]: 'трек',
      [EVENT_NOMINATIONS_OVERRIDES.TOPICS]: 'тематику',
      [EVENT_NOMINATIONS_OVERRIDES.SITES]: 'площадку',
      [EVENT_NOMINATIONS_OVERRIDES.CATEGORIES]: 'рубрику',
      [EVENT_NOMINATIONS_OVERRIDES.DIRECTIONS]: 'направление',
      [EVENT_NOMINATIONS_OVERRIDES.DISCIPLINES]: 'дисциплину',
    },
    counted: {
      [EVENT_NOMINATIONS_OVERRIDES.NOMINATIONS]: 'номинация | номинации | номинаций',
      [EVENT_NOMINATIONS_OVERRIDES.SECTIONS]: 'секция | секции | секций',
      [EVENT_NOMINATIONS_OVERRIDES.TRACKS]: 'трек | треки | треков',
      [EVENT_NOMINATIONS_OVERRIDES.TOPICS]: 'тематика | тематики | тематик',
      [EVENT_NOMINATIONS_OVERRIDES.SITES]: 'площадка | площадки | площадок',
      [EVENT_NOMINATIONS_OVERRIDES.CATEGORIES]: 'рубрика | рубрики | рубрик',
      [EVENT_NOMINATIONS_OVERRIDES.DIRECTIONS]: 'направление | направления | направлений',
      [EVENT_NOMINATIONS_OVERRIDES.DISCIPLINES]: 'дисциплина | дисциплины | дисциплин',
    },
  },

  options: {
    active_members_count: '{count} участник | {count} участника | {count} участников',
    organizers_count: '{count} организатор | {count} организатора | {count} организаторов',
    regions_count: '{count} регион | {count} региона | {count} регионов',
    experts_count: '{count} эксперт | {count} эксперта | {count} экспертов',
  },

  results: {
    members_count: 'участник | участника | участников',
    organizers_count: 'организатор | организатора | организаторов',
    regions_count: 'регион | региона | регионов',
    experts_count: 'эксперт | эксперта | экспертов',
  },
};
